// extracted by mini-css-extract-plugin
export default {"header":"ask-for-help_header__k64YO","close":"ask-for-help_close__NpNJg","group":"ask-for-help_group__uXnG3","model":"ask-for-help_model__QHVJX","file":"ask-for-help_file__vUq-1"};